import React from 'react';
import PropTypes from 'prop-types';

function BasicQuoteInformation({
  quoteNumber, quoteStatus, createdAt, expiresAt, loadError,
}) {
  return (
    <div className="card bg-light" style={{ minHeight: '4rem' }}>
      <div className="card-body">
        {!loadError && (
          <h5 className="card-title">
            Quote Number:
            {' '}
            {quoteNumber}
          </h5>
        )}
        <div className="card-text">
          {
          !loadError
            ? (
              <ul className="list-unstyled">
                <li>
                  <b>Status:</b>
                  {' '}
                  {quoteStatus}
                </li>
                <li>
                  <b>Created:</b>
                  {' '}
                  {createdAt}
                </li>
                <li>
                  <b>Expires:</b>
                  {' '}
                  {expiresAt}
                </li>
              </ul>
            )
            : (
              <p className="text-danger">
                Quote Not found. Try again here:
                {' '}
                <a href="/p/order-quote/search">Order Lookup</a>
                .
              </p>
            )
         }
        </div>
        <small href="#" className="card-link">More details available on your Room Alert Account.</small>
      </div>
    </div>
  );
}

BasicQuoteInformation.propTypes = {
  quoteNumber: PropTypes.string.isRequired,
  quoteStatus: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  expiresAt: PropTypes.string.isRequired,
  loadError: PropTypes.bool.isRequired,
};

export default BasicQuoteInformation;
